<!-- 字段配置 -->
<template>
<basic-container class="keySetup">
  <div class="width-p100 bb-sm-primary mb-xxs pb-xs ds-fx flex-direction-row justify-content-start align-items-center">
    <i class="el-icon-document color-primary mr-sm"></i>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{path:'/table/tableList',query:{runId:$route.query.runId,name:'数据窗口管理'} }">数据窗口管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.query.sname}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="topSearch">
    <m-form ref="searchForm" v-model="query" :option="option" @submit="searchChange" @reset="searchReset"></m-form>
  </div>
  <!-- 功能按钮和辅助按钮区域区域 -->
  <el-row class="width-p100 ds-fx flex-direction-row align-items-center justify-content-start flex-wrap mb-none">
    <!-- 功能按钮区域 -->
    <el-col span="12" class="mb-xxs ds-fx flex-direction-row justify-content-start align-items-center">
      <el-button type="success" size="mini" icon="el-icon-plus" @click="handleAdd">新 增</el-button>
      <!-- <el-button icon="el-icon-printer" type="primary" size="mini" @click="printDivClick">打印</el-button>
      <el-button icon="el-icon-download" type="primary" size="mini" @click="excelClick">导出</el-button> -->
      <el-button type="success" size="mini" icon="el-icon-connection" @click="handleConfig">生成字段配置</el-button>
      <!-- <el-button type="success" size="mini" icon="el-icon-connection" @click="teset(100)">100</el-button>
      <el-button type="success" size="mini" icon="el-icon-connection" @click="teset(130)">130</el-button>
      <el-button type="success" size="mini" icon="el-icon-connection" @click="teset(150)">150</el-button> -->
      <!-- <el-button type="success" size="mini" icon="el-icon-connection" @click="teset(180)">180</el-button> -->
      <!-- <el-button type="success" size="mini" icon="el-icon-connection" @click="teset(200)">200</el-button> -->
      <!-- <el-button type="success" size="mini" icon="el-icon-connection" @click="teset(300)">300</el-button> -->
      <!-- <el-button type="success" size="mini" icon="el-icon-connection" @click="teset1">添加事件</el-button>
      <el-button type="success" size="mini" icon="el-icon-connection" @click="teset2(137)">修改收索宽度137</el-button>
      <el-button type="success" size="mini" icon="el-icon-connection" @click="teset4()">只返回数据</el-button>
      <el-button type="success" size="mini" icon="el-icon-connection" @click="teset3(true)">是否搜索</el-button> -->
    </el-col>
    <!-- 辅助按钮区域 --> 
    <el-col span="12" class="mb-xxs ds-fx flex-direction-row justify-content-end align-items-center">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <el-button icon="el-icon-refresh" size="mini" circle @click="onLoad"></el-button>
      </el-tooltip>
    </el-col>
  </el-row>
  <div id="printDiv">
    <ux-grid
      ref="plxTable"
      stripe   
      :height="tableHeightFn()"
      size="mini"
      :edit-config="{trigger: 'click', mode: 'cell'}"
      @selection-change="handleSelectionChange"
      >
      <ux-table-column align="center" type="checkbox" width="50" />
      <ux-table-column field="label" title="名称" min-width="140" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" v-model="scope.row.label" @change="changeData({label:scope.row.label,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <ux-table-column field="prop" title="prop值" min-width="140" align="center"></ux-table-column>
      <ux-table-column field="type" title="类型"  width="100" align="center"></ux-table-column>
      <ux-table-column field="listSort" title="排序" width="100" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" type="number" v-model="scope.row.listSort" @change="changeData({listSort:scope.row.listSort,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <ux-table-column field="width" title="宽度" width="100" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" type="number" v-model="scope.row.width" @change="changeData({width:scope.row.width,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <ux-table-column field="formLabelWidth" title="新增修改宽度" width="100" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" type="number" v-model="scope.row.formLabelWidth" @change="changeData({formLabelWidth:scope.row.formLabelWidth,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <ux-table-column field="colQianzhui" title="前缀" min-width="140" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" v-model="scope.row.colQianzhui" @change="changeData({colQianzhui:scope.row.colQianzhui,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <!-- <ux-table-column field="addDisplay" title="新增显示" width="100" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" type="number" v-model="scope.row.addDisplay" @change="changeData({addDisplay:scope.row.addDisplay,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <ux-table-column field="editDisplay" title="修改显示" width="100" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" type="number" v-model="scope.row.editDisplay" @change="changeData({editDisplay:scope.row.editDisplay,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column> -->
      <ux-table-column field="format" title="format" width="220" edit-render align="center">
        <template v-slot:edit="scope">
          <el-input size="mini" v-model="scope.row.format" @change="changeData({format:scope.row.format,id:scope.row.id})"></el-input>
        </template>
      </ux-table-column>
      <ux-table-column field="status" title="是否返回" width="120" edit-render align="center">
        <template v-slot="{ row }">
          {{row.status==0?'配置数据都返回':row.status==1?'都不返回':'只返回数据'}}
        </template>
        <template v-slot:edit="scope">
          <el-select size="mini" v-model="scope.row.status" placeholder="请选择" @change="changeData({status:scope.row.status,id:scope.row.id})">
            <el-option label="配置数据都返回" :value="0"></el-option>
            <el-option label="都不返回" :value="1"></el-option>
            <el-option label="只返回数据" :value="2"></el-option>
          </el-select>
        </template>
      </ux-table-column>
      <ux-table-column field="hide" title="显示/隐藏" width="100" edit-render align="center">
        <template v-slot="{ row }">
          {{row.hide=='true'?'隐藏':'显示'}}
        </template>
        <template v-slot:edit="scope">
          <el-select size="mini" v-model="scope.row.hide" placeholder="请选择" @change="changeData({hide:scope.row.hide,id:scope.row.id})">
            <el-option label="隐藏" :value="'true'"></el-option>
            <el-option label="显示" :value="'false'"></el-option>
          </el-select>
        </template>
      </ux-table-column>
      <ux-table-column field="dwColType" title="是否维护" width="100" edit-render align="center">
        <template v-slot="{ row }">
          {{row.dwColType==0?'维护':row.dwColType==1?'不维护':''}}
        </template>
        <template v-slot:edit="scope">
          <el-select size="mini" v-model="scope.row.dwColType" placeholder="请选择" @change="changeData({dwColType:scope.row.dwColType,id:scope.row.id})">
            <el-option label="维护" :value="'0'"></el-option>
            <el-option label="不维护" :value="'1'"></el-option>
          </el-select>
        </template>
      </ux-table-column>
      <ux-table-column field="search" title="是否搜索" width="100" edit-render align="center">
        <template v-slot="{ row }">
          {{row.search=='false'?'否':row.search=='true'?'是':''}}
        </template>
        <template v-slot:edit="scope">
          <el-select size="mini" v-model="scope.row.search" placeholder="请选择" @change="changeData({search:scope.row.search,id:scope.row.id})">
            <el-option label="否" :value="'false'"></el-option>
            <el-option label="是" :value="'true'"></el-option>
          </el-select>
        </template>
      </ux-table-column>
      <ux-table-column field="dicUrl" title="字典链接" width="100" align="center" resizable>
      </ux-table-column>
      <ux-table-column title="操作" fixed="right" width="150" align="center">
        <template v-slot="{ row }">
          <el-button type="text" icon="el-icon-edit" size="mini" @click.stop="handleEdit(row)">编辑更多</el-button>
          <el-button type="text" icon="el-icon-delete" size="mini" @click.stop="handleDelete(row)">删除</el-button>
        </template>
      </ux-table-column>
    </ux-grid>
  </div>
  <div class="ux-page">
    <footer>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </footer>
  </div>
</basic-container>
</template>
<script>
import MForm from '@/components/table/template/mform';
import {getKeyList,updateKeyList,deleteKeyList} from "@/api/table/table";
import {processDeal} from '@/api/home/home';
export default {
components:{
  MForm,
},
data() {
  return {
    query: {}, //猜测是搜索内容
    loading: true,  //loading
    page: {  //当前页
      pageSize: 20,
      currentPage: 1,
      total: 0
    },
    option: {
      labelWidth:0,
      menuSpan:4,
      enter:true,
      noLabel:true,
      submitText: '搜索',
      submitIcon: 'el-icon-search',
      column: [
        {
          label: "名称",
          prop: "label",
          type: "input",
          span:6,
        },
        {
          label: "prop值",
          prop: "prop",
          type: "input",
          span:6,
        },
        {
          label: "类型",
          prop: "type",
          type: "input",
          span:6,
        },
        {
          label: "是否返回",
          prop: "status",
          type: "select",
          span:6,
          dicData:[
            {
              label:"配置数据都返回",
              value:"0"
            },
            {
              label:"都不返回",
              value:"1"
            },
            {
              label:"只返回数据",
              value:"2"
            },
          ]
        },
        {
          label: "是否显示",
          prop: "hide",
          type: "select",
          span:6,
          dicData:[
            {
              label:"显示",
              value:"false"
            },
            {
              label:"隐藏",
              value:"true"
            }
          ]
        }
      ]
    },
    data: [],
    currentArr: []
  };
},
computed: {},
methods: {
  async teset(value) {
    let arr = []
    this.currentArr.forEach(item => {
      arr.push(updateKeyList(this.$qs.stringify({id:item,width: value})))
    })
    await Promise.all(arr)
    this.onLoad();
  },
  async teset1(value) {
    let arr = []
    this.currentArr.forEach(item => {
      arr.push(updateKeyList(this.$qs.stringify({id:item,linkType: '2',linkMethod: '10',linkPath: 'glbmxDetail' })))
    })
    await Promise.all(arr)
    this.onLoad();
  },
  async teset2(value) {
    let arr = []
    this.currentArr.forEach(item => {
      arr.push(updateKeyList(this.$qs.stringify({id:item,formLabelWidth: value})))
    })
    await Promise.all(arr)
    this.onLoad();
  },
  async teset4(value) {
    let arr = []
    this.currentArr.forEach(item => {
      arr.push(updateKeyList(this.$qs.stringify({id:item,status: 2})))
    })
    await Promise.all(arr)
    this.onLoad();
  },
  async teset3(value) {
    let arr = []
    this.currentArr.forEach(item => {
      arr.push(updateKeyList(this.$qs.stringify({id:item,search: value})))
    })
    await Promise.all(arr)
    this.onLoad();
  },
  handleSelectionChange(value) {
    let arr = []
    value.forEach(item => {arr.push(item.id)})
    this.currentArr = arr
    console.log(value,'value')
  },
  // 行修改
  handleEdit(row) {
    this.$router.push({
      path: "/table/addTableKey",
      query: {
        runId:this.$route.query.runId,
        id: this.$route.query.id,
        name:"修改字段",
        tableKeyId: row.id
      }
    });
  },
  // 生成字段配置
  handleConfig(){
    processDeal({obj:JSON.stringify({id:7,dwid:this.$route.query.id,append:1})}).then(res=>{
      this.onLoad();
      this.$message.success("生成成功!");
    },err=>{
      
    })
  },
  searchReset() {
    this.query = {};
    this.onLoad();
  },
  searchChange(params, done) {
    this.query = params;
    this.page.currentPage = 1;
    this.onLoad();
    done();
  },
  // 顶部添加卡片
  handleAdd() {
    this.$router.push({
      path:"/table/addTableKey",
      query:{
        runId:this.$route.query.runId,
        name:"增加字段",
        id:this.$route.query.id,
      }
    })
  },
  // 删除
  handleDelete(row) {
    this.loading=true;
    this.$confirm("确定删除该字段吗?", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {      
      deleteKeyList(this.$qs.stringify({
        ids:row.id,
      })).then(() => {
        this.$message.success("删除成功!");
        this.loading=false;
        this.onLoad();
      }, error => {
        this.loading=false;
        
      });
    });
  },
  currentChange(currentPage) {
    this.page.currentPage = currentPage;
    this.onLoad();
  },
  sizeChange(pageSize) {
    this.page.pageSize = pageSize;
    this.page.currentPage = 1;
    this.onLoad();
  },
  refreshChange() {
    this.onLoad();
  },
  onLoad() {
    this.loading = true;
    getKeyList(
      this.$route.query.id,
      this.page.currentPage,
      this.page.pageSize,
      this.query,
    ).then(res => {
      const data = res.data.data;
      this.page.total = data.total;
      this.data = data.records;
      this.$refs.plxTable.reloadData(data.records);
      this.loading = false;
    },error=>{
      this.loading=false;
      
    });
  },
  // 获取表格最大高度
  tableHeightFn(){
    let height=document.getElementById("avue-view");
    if(height){
      if(height.clientHeight>=508){
        return height.clientHeight-208;
      }else{
        return 300
      }
    }
  },
  // 修改数据
  changeData(form){
    this.loading=true;
    updateKeyList(this.$qs.stringify(form)).then(() => {
      this.$message.success("修改成功!");
      this.loading=false;
      this.onLoad();
    }, error => {
      this.loading=false;
      
    });
  }
},
created() {
  // this.onLoad();
},
activated() {
  this.onLoad();
},
}
</script>
<style lang='scss' scoped>
.keySetup{
  .url{
    cursor: pointer;
    color: #2E5AE8;
  }
  .ux-page{
    margin-top: 14px;
    height:32px;
    footer{
      float: right;
    }  
  }
  /deep/ .elx-table .elx-cell {
    padding-left: 0;
    padding-right: 0;
  }
  /deep/.el-form-item__label {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
  }
  /deep/.el-form-item__content {
    margin-left: 0px !important;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
  }
  /deep/td {
    height: 32px !important;
  }
  /deep/.el-transfer-panel {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;
    background: #FFF;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
  }
  /deep/.elx-table .row--hover {
    background-color: #bfdbe9 !important;
  }
}
</style>
